module.exports = __webpack_public_path__ + "static/img/6.251bf02.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/guangdong/6.jpg
// module id = aPgJ
// module chunks = 1